import React from "react";
import { MobileChatContainer } from "@/components/agent/chat/MobileChatContainer";
import { DesktopChatContainer } from "@/components/agent/chat/DesktopChatContainer";

interface ChatContainerProps {
  isMobile?: boolean;
  constrainWidth?: boolean;
}

export const ChatContainer: React.FC<ChatContainerProps> = ({
  isMobile = false,
  constrainWidth = false,
}) => {
  // Choose the appropriate container based on device type
  if (isMobile) {
    return <MobileChatContainer />;
  }

  return <DesktopChatContainer constrainWidth={constrainWidth} />;
};
